export interface TimelineNode {
  date: string;
  title: string;
  desc: string;
  type: string;
}

export interface EventItem {
  id: string;
  title: string;
  category: string;
  status: "ongoing" | "progress" | "concluded";
  region: string;
  startDate: string;
  updatedAt: string;
  heat: number;
  summary: string;
  cover: string;
  tags: string[];
  timeline: TimelineNode[];
  keyPoints: { q: string; a: string }[];
}

export const eventList: EventItem[] = [
  {
    id: "elevator-fee",
    title: "老旧小区加装电梯费用分摊争议始末",
    category: "society",
    status: "progress",
    region: "多个城市",
    startDate: "2025-03-11",
    updatedAt: "2026-08-22",
    heat: 92,
    summary:
      "一栋六层老楼加装电梯的提案，从最初的三户反对，到方案四次修改，再到分摊系数重新测算，前后历时一年多。争议的核心始终是：不同楼层该承担多少费用，以及低楼层住户的采光补偿如何量化。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20an%20old%20residential%20building%20with%20a%20newly%20installed%20glass%20elevator%20shaft%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-01&orientation=landscape",
    tags: ["费用分摊", "社区治理", "方案协商"],
    timeline: [
      {
        date: "2025-03-11",
        title: "提案首次公示",
        desc: "楼栋张贴加装电梯征求意见稿，按楼层递增比例测算分摊，一、二层住户提出采光与噪音异议。",
        type: "事件发生",
      },
      {
        date: "2025-05-28",
        title: "首次协商未达成一致",
        desc: "参与协商的住户因分摊系数分歧较大，会议记录显示高层与低层住户诉求差距明显。",
        type: "协商进展",
      },
      {
        date: "2025-09-16",
        title: "方案二度修改",
        desc: "调整为一至二层免分摊、由其余楼层按比例补齐，并提出对低层住户的采光补偿参考区间。",
        type: "方案调整",
      },
      {
        date: "2026-02-04",
        title: "第三方测算介入",
        desc: "引入独立测算对采光影响与噪音时段进行记录，形成可供各方参照的中立数据说明。",
        type: "调查核实",
      },
      {
        date: "2026-06-19",
        title: "分摊比例正式细化",
        desc: "按楼层、面积与使用频次三因素权重细化分摊，并明确补偿款项的支付节点与方式。",
        type: "最新进展",
      },
      {
        date: "2026-08-22",
        title: "施工许可进入公示期",
        desc: "相关许可材料进入公示阶段，公示期内住户仍可提交书面意见，事件持续跟进中。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "为什么低楼层住户会反对？",
        a: "主要顾虑集中在采光遮挡、施工期噪音以及日常运行带来的隐私感变化，而早期方案中这部分影响并未折算为任何补偿。",
      },
      {
        q: "分摊系数后来是怎么定的？",
        a: "最终采用楼层系数、建筑面积与使用频次三项加权的方式，并单独列出低层住户的补偿参考区间，使各方承担与受益更接近。",
      },
      {
        q: "目前进展到哪一步？",
        a: "施工许可材料已进入公示期，公示期内住户可提交书面意见，尚需完成意见汇总后才能进入施工准备环节。",
      },
    ],
  },
  {
    id: "newenergy-delay",
    title: "新能源车型交付延期与退订问题梳理",
    category: "consumer",
    status: "ongoing",
    region: "全国范围",
    startDate: "2025-08-02",
    updatedAt: "2026-09-01",
    heat: 88,
    summary:
      "一款热门车型在订单量超出预期后，交付周期从承诺的六周延长至十四周以上。围绕预订金能否退还、延期期间的价格与权益如何计算，购车者与销售渠道之间出现了多种说法。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20modern%20electric%20car%20waiting%20in%20a%20delivery%20queue%20outside%20a%20minimal%20showroom%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-02&orientation=landscape",
    tags: ["交付周期", "预订金", "消费权益"],
    timeline: [
      {
        date: "2025-08-02",
        title: "上市承诺交付周期",
        desc: "发布时对外说明的基础版交付周期为六周左右，预订通道开放后短时间内订单量显著上升。",
        type: "事件发生",
      },
      {
        date: "2025-10-14",
        title: "交付周期首次延长",
        desc: "部分预订用户收到通知，交付时间调整至十二周，渠道方解释为产能爬坡需要时间。",
        type: "进展",
      },
      {
        date: "2026-01-09",
        title: "预订单状态不透明",
        desc: "用户反映无法查询自己在排产队列中的位置，同一时间下订的订单交付顺序存在差异。",
        type: "争议焦点",
      },
      {
        date: "2026-04-21",
        title: "退订政策出现分歧",
        desc: "不同门店对预订金是否可退给出不一致答复，引发集中咨询与投诉。",
        type: "消费者反馈",
      },
      {
        date: "2026-07-08",
        title: "公开说明排产规则",
        desc: "渠道方公开排产规则说明，承诺按订单确认时间排序，并对超出承诺周期的订单提供权益补充。",
        type: "官方回应",
      },
      {
        date: "2026-09-01",
        title: "过渡期权益执行中",
        desc: "延期订单的权益补偿进入执行阶段，部分用户反馈到账时间仍有差异，事件继续跟踪。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "预订单上的交付时间有约束力吗？",
        a: "需要区分“预计交付时间”与“承诺交付时间”。多数预订页面标注的是预计时间，属于参考区间，因此延期时较难直接据此主张违约。",
      },
      {
        q: "预订金和定金有什么区别？",
        a: "预订金通常具备可退属性，而定金在法律上具有担保性质。用户在下订时应确认页面用词与实际收款凭证，二者对应的退还规则不同。",
      },
      {
        q: "目前争议的主要分歧点是什么？",
        a: "集中在排产顺序是否透明、延期期间的价格变动如何计算，以及不同渠道对退订政策的执行标准是否统一。",
      },
    ],
  },
  {
    id: "kids-mode",
    title: "短视频青少年模式执行情况争议追踪",
    category: "tech",
    status: "concluded",
    region: "线上平台",
    startDate: "2024-11-19",
    updatedAt: "2026-05-30",
    heat: 79,
    summary:
      "多方对多个短视频平台的青少年模式进行实际使用测试，发现时长限制、内容过滤与身份核验在不同设备上的表现不一，由此引发关于功能是否落到实处的讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20smartphone%20screen%20with%20abstract%20content%20grid%20being%20filtered%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-03&orientation=landscape",
    tags: ["平台规则", "内容治理", "未成年人保护"],
    timeline: [
      {
        date: "2024-11-19",
        title: "第三方测试结果公布",
        desc: "测试发现部分平台青少年模式可通过简单操作退出，内容池与默认模式差异有限。",
        type: "事件发生",
      },
      {
        date: "2025-01-07",
        title: "平台集中回应",
        desc: "多家平台表示将加强身份核验与使用时长管理，并优化内容分级标签。",
        type: "官方回应",
      },
      {
        date: "2025-06-25",
        title: "再次复核出现分歧",
        desc: "复测显示时长限制有所改善，但内容池质量与退出路径的差异依然存在。",
        type: "复核结果",
      },
      {
        date: "2025-12-10",
        title: "统一规范意见发布",
        desc: "相关规范对身份核验方式、内容推荐范围与退出确认流程提出更具体的要求。",
        type: "规则完善",
      },
      {
        date: "2026-05-30",
        title: "阶段性结论",
        desc: "主要平台的时长限制与身份核验环节已完成整改，事件标注为“已有结论”。",
        type: "结论",
      },
    ],
    keyPoints: [
      {
        q: "青少年模式为什么容易被绕过？",
        a: "早期多数平台仅依赖本机设置的简单密码，未与账号实名与设备信息绑定，重新安装或切换设备即可重置状态。",
      },
      {
        q: "整改后主要变化是什么？",
        a: "时长限制与身份核验成为必选项，退出路径增加确认环节，内容推荐范围也做了更明确的分级限定。",
      },
    ],
  },
  {
    id: "parking-scenic",
    title: "景区停车收费争议与后续整改记录",
    category: "consumer",
    status: "progress",
    region: "某山区景区",
    startDate: "2025-05-03",
    updatedAt: "2026-04-15",
    heat: 71,
    summary:
      "假期期间，自驾游客反映景区外围停车场按次收费且在入口处未清晰公示标准，取车时才发现费用高于预期。争议随后从收费本身，延伸到标识设置与退费机制的完善。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20mountain%20scenic%20parking%20lot%20with%20cars%20and%20a%20fee%20notice%20board%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-04&orientation=landscape",
    tags: ["明码标价", "退费机制", "景区服务"],
    timeline: [
      {
        date: "2025-05-03",
        title: "游客集中反映收费问题",
        desc: "多名自驾游客反馈停车费用与预期不符，入口处公示信息位于不显眼位置。",
        type: "事件发生",
      },
      {
        date: "2025-05-20",
        title: "现场标识调整",
        desc: "管理方在主入口与车道沿线增设收费公示牌，标明计费方式与投诉电话。",
        type: "整改措施",
      },
      {
        date: "2025-09-12",
        title: "补充退费流程",
        desc: "针对未入场即驶离的车辆，明确不收取费用并提供现场核验通道。",
        type: "机制完善",
      },
      {
        date: "2026-04-15",
        title: "假期前复核",
        desc: "高峰期前的复核显示标识已到位，个别时段人工引导仍不足，持续观察中。",
        type: "最新进展",
      },
    ],
    keyPoints: [
      {
        q: "停车收费争议的关键是什么？",
        a: "并非收费高低本身，而是计费方式与价格是否在进入停车场前被清晰告知，未公示直接收费容易引发纠纷。",
      },
      {
        q: "整改后有哪些可见变化？",
        a: "主入口与车道沿线增设公示牌，明确计费单位与投诉渠道，并补充了未入场车辆的免收流程。",
      },
    ],
  },
  {
    id: "gym-closure",
    title: "预付费健身门店闭店退款风波梳理",
    category: "consumer",
    status: "ongoing",
    region: "多个连锁门店",
    startDate: "2025-02-18",
    updatedAt: "2026-08-06",
    heat: 84,
    summary:
      "连锁健身门店在未提前充分告知的情况下暂停营业，持有多年期会员卡的消费者面临退款无门的处境。事件从单店问题逐步扩散至同一品牌的多地门店，退款进度成为长期关注点。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20closed%20fitness%20studio%20entrance%20with%20locked%20glass%20doors%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-05&orientation=landscape",
    tags: ["预付费", "退款进度", "契约履行"],
    timeline: [
      {
        date: "2025-02-18",
        title: "门店突然暂停营业",
        desc: "门店张贴通知称设备检修暂停营业，会员在当日无法进行预约与到店消费。",
        type: "事件发生",
      },
      {
        date: "2025-03-05",
        title: "退款登记开启",
        desc: "运营方开通线上登记渠道，按会员卡剩余时长折算退款金额，登记周期为一个月。",
        type: "处理方案",
      },
      {
        date: "2025-07-22",
        title: "登记与到账存在时间差",
        desc: "完成登记的会员反馈退款到账进度不一，部分订单长时间停留在审核状态。",
        type: "消费者反馈",
      },
      {
        date: "2025-11-30",
        title: "引入分批退款说明",
        desc: "运营方说明按登记顺序分批处理，并公布各批次预计完成的时间区间。",
        type: "官方回应",
      },
      {
        date: "2026-08-06",
        title: "退款仍在推进",
        desc: "多数已登记订单完成退款，少数涉及转卡与赠品折算的订单仍在核算，事件持续追踪。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "预付费卡余额能全额退吗？",
        a: "通常按剩余服务时长或次数折算，赠品、折扣与已使用部分会影响最终金额，需以合同约定与实际使用记录为准。",
      },
      {
        q: "为什么退款进度差异明显？",
        a: "涉及转卡、拼卡与赠课折算的订单需要重新核算，处理复杂度高于标准订单，因此到账时间存在差异。",
      },
      {
        q: "消费者可以做哪些准备？",
        a: "保留合同、付款凭证与沟通记录，及时完成官方登记，并留存登记编号便于后续查询进度。",
      },
    ],
  },
  {
    id: "delivery-timeout",
    title: "外卖配送超时扣款规则争议追踪",
    category: "society",
    status: "progress",
    region: "多个城市",
    startDate: "2025-06-09",
    updatedAt: "2026-07-19",
    heat: 76,
    summary:
      "配送超时后的费用扣减规则引发骑手与消费者的双重关注：消费者关心超时是否获得补偿，骑手关心扣款是否与实际路况匹配。围绕规则透明度，事件经历了从质疑到部分调整的过程。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20delivery%20rider%20on%20a%20rainy%20city%20street%20with%20abstract%20route%20lines%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-06&orientation=landscape",
    tags: ["平台规则", "配送时效", "劳动权益"],
    timeline: [
      {
        date: "2025-06-09",
        title: "扣款规则引发讨论",
        desc: "骑手反映恶劣天气与小区管控导致的超时同样被扣款，规则未区分客观因素。",
        type: "事件发生",
      },
      {
        date: "2025-08-14",
        title: "平台说明计费逻辑",
        desc: "平台公开超时判定与扣款上限，说明将逐步引入天气与路况系数。",
        type: "官方回应",
      },
      {
        date: "2025-12-02",
        title: "部分城市试点调整",
        desc: "在试点城市中，恶劣天气自动延长预计送达时间，超时扣款比例相应下调。",
        type: "试点推进",
      },
      {
        date: "2026-07-19",
        title: "推广范围待明确",
        desc: "试点效果反馈较好，非试点城市骑手希望规则尽快统一，事件继续跟进。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "超时扣款争议的核心在哪？",
        a: "在于规则是否考虑了骑手无法控制的因素，例如恶劣天气、门禁登记与商家出餐延迟，这些都会显著影响送达时间。",
      },
      {
        q: "试点带来了什么变化？",
        a: "试点城市引入天气与路况系数，自动延长预计时间并下调扣款比例，超时争议明显减少。",
      },
    ],
  },
  {
    id: "food-label",
    title: "预包装食品配料标注不清事件梳理",
    category: "health",
    status: "concluded",
    region: "线上销售",
    startDate: "2024-09-05",
    updatedAt: "2026-03-12",
    heat: 68,
    summary:
      "有消费者在购买休闲食品时发现，页面宣传强调的配料在实物标签中排序靠后，且部分复配原料未展开标注。围绕宣传与标签是否一致，事件经历了抽检、说明与标签改版的过程。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20food%20package%20label%20being%20inspected%20with%20a%20magnifying%20glass%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-07&orientation=landscape",
    tags: ["食品标签", "宣传一致", "复配原料"],
    timeline: [
      {
        date: "2024-09-05",
        title: "消费者提出质疑",
        desc: "页面宣传中重点提及的原料，在实物标签配料表中排序较后，实际含量存疑。",
        type: "事件发生",
      },
      {
        date: "2024-11-18",
        title: "抽检结果公布",
        desc: "抽检显示部分批次复配原料未按规范展开标注，要求限期整改。",
        type: "检测结果",
      },
      {
        date: "2025-04-27",
        title: "标签完成改版",
        desc: "相关批次更换包装标签，复配原料展开标注，页面宣传用语同步收缩为可核验表述。",
        type: "整改完成",
      },
      {
        date: "2026-03-12",
        title: "阶段性结论",
        desc: "后续复核未再发现同类标注问题，事件标注为“已有结论”。",
        type: "结论",
      },
    ],
    keyPoints: [
      {
        q: "配料表排序意味着什么？",
        a: "配料按加入量由多到少排列，排序靠后说明实际用量较少，与页面宣传所强调的程度可能存在落差。",
      },
      {
        q: "复配原料为什么需要展开标注？",
        a: "展开标注可以让消费者看清复合配料内部的成分构成，避免只看到笼统名称而无法判断真实配方。",
      },
    ],
  },
  {
    id: "livestream-return",
    title: "直播带货退货难争议与规则调整",
    category: "consumer",
    status: "progress",
    region: "线上直播",
    startDate: "2025-04-27",
    updatedAt: "2026-06-28",
    heat: 81,
    summary:
      "部分消费者反映，直播间展示的商品与实物存在差异，申请退货时被以“已拆封影响二次销售”为由拒绝。争议推动平台细化退货判定标准，并明确哪些情形不得作为拒绝理由。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20live%20streaming%20setup%20with%20a%20product%20and%20return%20parcel%20boxes%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-08&orientation=landscape",
    tags: ["直播电商", "七天无理由", "退货标准"],
    timeline: [
      {
        date: "2025-04-27",
        title: "退货申请被集中拒绝",
        desc: "多名消费者反馈因拆封验货被认定影响二次销售，退货申请被驳回。",
        type: "事件发生",
      },
      {
        date: "2025-07-15",
        title: "平台介入核查",
        desc: "平台对争议订单进行复核，发现部分驳回理由缺少具体依据。",
        type: "核查进展",
      },
      {
        date: "2025-11-08",
        title: "细化判定标准",
        desc: "明确拆封验货、合理试用不应直接视为影响二次销售，需结合商品性质判断。",
        type: "规则调整",
      },
      {
        date: "2026-06-28",
        title: "执行情况观察",
        desc: "规则落地后驳回率下降，但个别商家仍以模糊理由延迟处理，事件继续跟踪。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "拆封后一定不能退吗？",
        a: "并非绝对。为查验商品而进行的必要拆封与合理试用，通常不应直接作为拒绝理由，具体还需结合商品性质与是否影响二次销售判断。",
      },
      {
        q: "规则调整后有什么变化？",
        a: "平台细化了判定标准，要求商家说明具体依据，模糊理由驳回的情况有所减少。",
      },
    ],
  },
  {
    id: "pet-transport",
    title: "宠物托运途中意外责任认定梳理",
    category: "safety",
    status: "ongoing",
    region: "跨城线路",
    startDate: "2025-09-21",
    updatedAt: "2026-08-11",
    heat: 74,
    summary:
      "一次跨城宠物托运中发生意外，围绕运输方的看护义务、交接环节的确认流程以及责任划分，委托人与服务方各执一词。事件推动了交接确认流程的细化讨论。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20pet%20carrier%20crate%20at%20a%20transport%20handover%20point%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-09&orientation=landscape",
    tags: ["托运服务", "责任划分", "交接流程"],
    timeline: [
      {
        date: "2025-09-21",
        title: "途中发生意外",
        desc: "托运途中出现状况，委托人在到达后才发现，双方对交接时的状态记录说法不一。",
        type: "事件发生",
      },
      {
        date: "2025-10-30",
        title: "责任认定出现分歧",
        desc: "服务方主张已按流程运输，委托人认为看护与交接确认环节存在明显缺失。",
        type: "争议焦点",
      },
      {
        date: "2026-01-16",
        title: "交接流程补充规范",
        desc: "相关平台要求托运前后留存状态影像与交接确认记录，明确异常情况的上报时限。",
        type: "规则完善",
      },
      {
        date: "2026-08-11",
        title: "个案仍在协商",
        desc: "具体责任划分仍在协商中，流程规范的落地效果持续观察。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "责任认定的难点在哪？",
        a: "在于交接环节的状态记录是否完整。若托运前后缺少影像与确认记录，途中出现状况时很难界定责任发生的具体阶段。",
      },
      {
        q: "流程规范补充了什么？",
        a: "要求托运前后留存状态影像、填写交接确认记录，并明确异常情况的上报时限。",
      },
    ],
  },
  {
    id: "course-refund",
    title: "在线课程退费难集体反馈追踪",
    category: "tech",
    status: "progress",
    region: "线上教育",
    startDate: "2025-07-14",
    updatedAt: "2026-05-09",
    heat: 70,
    summary:
      "多名学员在课程内容与宣传存在差异后申请退费，却遭遇课时计算方式不透明、赠课是否计入折算等问题的反复拉扯，由此形成集中反馈。",
    cover:
      "https://readdy.ai/api/search-image?query=Editorial%20documentary%20illustration%20of%20a%20laptop%20showing%20online%20course%20modules%20with%20a%20refund%20form%20beside%20it%2C%20warm%20paper%20texture%20background%2C%20muted%20beige%20and%20deep%20crimson%20accents%2C%20minimal%20abstract%20composition%2C%20soft%20grain%2C%20no%20text&width=800&height=600&seq=event-cover-10&orientation=landscape",
    tags: ["在线课程", "退费折算", "宣传一致"],
    timeline: [
      {
        date: "2025-07-14",
        title: "学员集中申请退费",
        desc: "课程内容与试听阶段介绍存在差异，多名学员提出退费申请。",
        type: "事件发生",
      },
      {
        date: "2025-09-03",
        title: "折算方式引发争议",
        desc: "退费金额按原价而非实付优惠价折算课时，学员认为与实际支付不符。",
        type: "争议焦点",
      },
      {
        date: "2026-01-22",
        title: "公布折算口径",
        desc: "机构明确按实付金额与已解锁课时比例折算，赠课不再计入可退范围并提前说明。",
        type: "官方回应",
      },
      {
        date: "2026-05-09",
        title: "退费陆续办理",
        desc: "按新口径的退费陆续办理，个别早期订单仍在核对，事件继续跟踪。",
        type: "持续追踪",
      },
    ],
    keyPoints: [
      {
        q: "退费为什么按原价折算会引起争议？",
        a: "学员实际支付的是优惠价，若按原价折算剩余课时，会显著拉低可退金额，与消费者的实际支出感受不一致。",
      },
      {
        q: "新的折算口径是什么？",
        a: "按实际支付金额与已解锁课时比例折算，赠课不计入可退范围，且需在下单前明确告知。",
      },
    ],
  },
];